var _defs, _mask;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailbale(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg435",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs439",
    fill: "#07b30a"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath453",
    fill: "#07b30a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path451",
    fill: "#07b30a"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "custom",
    fill: "#07b30a"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#custom)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g441",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g443",
    transform: "translate(355.0234,323.0869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -134.174,-134.174 -63.873,63.872",
    style: {
      fill: "none",
      stroke: "#07b30a",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path445"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g449",
    clipPath: "url(#clipPath453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g455",
    transform: "translate(492,256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-130.339 -105.661,-236 -236,-236 -130.339,0 -236,105.661 -236,236 0,130.339 105.661,236 236,236 C -105.661,236 0,130.339 0,0 Z",
    style: {
      fill: "none",
      stroke: "#07b30a",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path457"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailbale);
export default __webpack_public_path__ + "static/media/availbale.41bb7c757d0e7d6908919f360809ec82.svg";
export { ForwardRef as ReactComponent };